import React from 'react'
import PropTypes from 'prop-types'
import BootstrapModal from 'react-bootstrap/Modal'
import './styles.css'

function Modal(props) {
  const {
    show,
    title,
    additionalHeaderItems,
    children,
    footer,
    className,
    modalClassName,
    headerClassName,
    bodyClassName,
    footerClassName,
    onHide
  } = props
  return (
    <BootstrapModal show={show} centered onHide={onHide} className={className} backdropClassName={className}>
      <div data-testid='modal' styleName='modal' className={modalClassName}>
        { title && (
          <div data-testid='modal-header' styleName='header' className={headerClassName}>
            <h1 styleName='title'>
              {title}
            </h1>
            {additionalHeaderItems}
          </div>
        )}
        <div data-testid='modal-body' styleName='body' className={bodyClassName}>
          {children}
        </div>
        <div data-testid='modal-footer' styleName='footer' className={footerClassName}>
          {footer}
        </div>
      </div>
    </BootstrapModal>
  )
}

Modal.propTypes = {
  show: PropTypes.bool.isRequired,
  children: PropTypes.node,
  showCloseButton: PropTypes.bool,
  footer: PropTypes.node
}

Modal.defaultProps = {
  onHide: () => {}
};

export default Modal
